import * as api from '../../api/maintenance/role';
import { makeApiActionCreatorV3 } from '../utils';

export const MODULES_FETCH_START = 'ROLE/MODULES_FETCH_START';
export const MODULES_FETCH_SUCCESS = 'ROLE/MODULES_FETCH_SUCCESS';
export const MODULES_FETCH_ERROR = 'ROLE/MODULES_FETCH_ERROR';

export const ROLES_FETCH_START = 'ROLE/ROLES_FETCH_START';
export const ROLES_FETCH_SUCCESS = 'ROLE/ROLES_FETCH_SUCCESS';
export const ROLES_FETCH_ERROR = 'ROLE/ROLES_FETCH_ERROR';

export const ROLE_CREATE_START = 'ROLE/ROLE_CREATE_START';
export const ROLE_CREATE_SUCCESS = 'ROLE/ROLE_CREATE_SUCCESS';
export const ROLE_CREATE_ERROR = 'ROLE/ROLE_CREATE_ERROR';

export const ROLE_DELETE_START = 'ROLE/ROLE_DELETE_START';
export const ROLE_DELETE_SUCCESS = 'ROLE/ROLE_DELETE_SUCCESS';
export const ROLE_DELETE_ERROR = 'ROLE/ROLE_DELETE_ERROR';

export const ROLE_UPDATE_START = 'ROLE/ROLE_UPDATE_START';
export const ROLE_UPDATE_SUCCESS = 'ROLE/ROLE_UPDATE_SUCCESS';
export const ROLE_UPDATE_ERROR = 'ROLE/ROLE_UPDATE_ERROR';

export const RIGHTS_FETCH_START = 'ROLE/RIGHTS_FETCH_START';
export const RIGHTS_FETCH_SUCCESS = 'ROLE/RIGHTS_FETCH_SUCCESS';
export const RIGHTS_FETCH_ERROR = 'ROLE/RIGHTS_FETCH_ERROR';

export const ROLE_RIGHTS_FETCH_START = 'ROLE/ROLE_RIGHTS_FETCH_START';
export const ROLE_RIGHTS_FETCH_SUCCESS = 'ROLE/ROLE_RIGHTS_FETCH_SUCCESS';
export const ROLE_RIGHTS_FETCH_ERROR = 'ROLE/ROLE_RIGHTS_FETCH_ERROR';

export const RIGHT_ASSIGN_START = 'ROLE/RIGHT_ASSIGN_START';
export const RIGHT_ASSIGN_SUCCESS = 'ROLE/RIGHT_ASSIGN_SUCCESS';
export const RIGHT_ASSIGN_ERROR = 'ROLE/RIGHT_ASSIGN_ERROR';

export const RIGHT_UNASSIGN_START = 'ROLE/RIGHT_UNASSIGN_START';
export const RIGHT_UNASSIGN_SUCCESS = 'ROLE/RIGHT_UNASSIGN_SUCCESS';
export const RIGHT_UNASSIGN_ERROR = 'ROLE/RIGHT_UNASSIGN_ERROR';

export const ALL_RIGHTS_UNASSIGN_START = 'ROLE/ALL_RIGHTS_UNASSIGN_START';
export const ALL_RIGHTS_UNASSIGN_SUCCESS = 'ROLE/ALL_RIGHTS_UNASSIGN_SUCCESS';
export const ALL_RIGHTS_UNASSIGN_ERROR = 'ROLE/ALL_RIGHTS_UNASSIGN_ERROR';

export const fetchModules = makeApiActionCreatorV3(
  api.fetchModules,
  MODULES_FETCH_START,
  MODULES_FETCH_SUCCESS,
  MODULES_FETCH_ERROR,
);
export const fetchRoles = makeApiActionCreatorV3(
  api.fetchRoles,
  ROLES_FETCH_START,
  ROLES_FETCH_SUCCESS,
  ROLES_FETCH_ERROR,
);
export const fetchRights = makeApiActionCreatorV3(
  api.fetchRights,
  RIGHTS_FETCH_START,
  RIGHTS_FETCH_SUCCESS,
  RIGHTS_FETCH_ERROR,
);
export const fetchRoleRights = makeApiActionCreatorV3(
  api.fetchRoleRights,
  ROLE_RIGHTS_FETCH_START,
  ROLE_RIGHTS_FETCH_SUCCESS,
  ROLE_RIGHTS_FETCH_ERROR,
);
export const createRole = makeApiActionCreatorV3(
  api.createRole,
  ROLE_CREATE_START,
  ROLE_CREATE_SUCCESS,
  ROLE_CREATE_ERROR,
);
export const updateRole = makeApiActionCreatorV3(
  api.updateRole,
  ROLE_UPDATE_START,
  ROLE_UPDATE_SUCCESS,
  ROLE_UPDATE_ERROR,
);
export const deleteRole = makeApiActionCreatorV3(
  api.deleteRole,
  ROLE_DELETE_START,
  ROLE_DELETE_SUCCESS,
  ROLE_DELETE_ERROR,
);
export const assignRight = makeApiActionCreatorV3(
  api.assignRight,
  RIGHT_ASSIGN_START,
  RIGHT_ASSIGN_SUCCESS,
  RIGHT_ASSIGN_ERROR,
);
export const unAssignRight = makeApiActionCreatorV3(
  api.unAssignRight,
  RIGHT_UNASSIGN_START,
  RIGHT_UNASSIGN_SUCCESS,
  RIGHT_UNASSIGN_ERROR,
);
export const unAssignAllRights = makeApiActionCreatorV3(
  api.unAssignAllRights,
  ALL_RIGHTS_UNASSIGN_START,
  ALL_RIGHTS_UNASSIGN_SUCCESS,
  ALL_RIGHTS_UNASSIGN_ERROR,
);
